import { getCurrentUser } from 'Src/ng2/store/selectors/current-user-selectors';
import { Auth } from 'Src/ng2/shared/auth/auth.service';
import { LoadCurrentUser } from './../../../store/actions/current-user-actions';
import { getCurrentUserLoadedStatus } from './../../../store/selectors/current-user-selectors';
import { tap, filter, switchMap, take, catchError } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

@Injectable()
export class CUNYGuard implements CanActivate {
  constructor (private store: Store<any>, private auth: Auth, private router: Router, private ImUser: ImUser) {}

  getFromStoreOrAPI (): Observable<any> {
    return this.store.pipe(
      select(getCurrentUserLoadedStatus),
      tap(async loaded => {
        if (!loaded) {
          const email = await this.auth.getCurrentUserEmail();
          this.store.dispatch(new LoadCurrentUser({ email }));
        }
      }),
      filter(loaded => loaded),
      switchMap(() => this.store.pipe(select(getCurrentUser))),
      take(1),
    );
  }

  canActivate (): Observable<UrlTree | boolean> {
    return this.getFromStoreOrAPI().pipe(
      switchMap((user) => {
        const isCUNYUser = this.ImUser.isCUNY(user);
        if (isCUNYUser) return of(true);
        else return of(this.router.createUrlTree(['home'])) as Observable<UrlTree>;
      }),
      catchError(() => of(false)),
    );
  }
}
